/**
 * String Utility Functions
 * Reusable string manipulation and conversion utilities
 */

/**
 * Convert camelCase to snake_case
 * @param {any} obj - Object, array, or primitive to convert
 * @returns {any} - Converted object/array/primitive
 */
export function toSnakeCase(obj) {
  if (obj === null || obj === undefined) return obj;
  if (Array.isArray(obj)) {
    return obj.map(item => toSnakeCase(item));
  }
  if (typeof obj !== 'object') return obj;

  const snakeCaseObj = {};
  for (const [key, value] of Object.entries(obj)) {
    const snakeKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
    snakeCaseObj[snakeKey] = toSnakeCase(value);
  }
  return snakeCaseObj;
}

/**
 * Convert snake_case to camelCase
 * @param {any} obj - Object, array, or primitive to convert
 * @returns {any} - Converted object/array/primitive
 */
export function toCamelCase(obj) {
  if (obj === null || obj === undefined) return obj;
  if (Array.isArray(obj)) {
    return obj.map(item => toCamelCase(item));
  }
  if (typeof obj !== 'object') return obj;

  const camelCaseObj = {};
  for (const [key, value] of Object.entries(obj)) {
    const camelKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
    camelCaseObj[camelKey] = toCamelCase(value);
  }
  return camelCaseObj;
}

